module.exports = __webpack_public_path__ + "img/252f430.svg";